import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaMobileAlt, FaServer, FaCogs, FaPalette } from 'react-icons/fa';

const services = [
  {
    id: 1,
    title: 'Web Development',
    description: 'Custom web applications built with the latest technologies to deliver exceptional user experiences.',
    icon: <FaLaptopCode className="text-primary-500" size={40} />,
  },
  {
    id: 2,
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications for iOS and Android that engage and delight users.',
    icon: <FaMobileAlt className="text-primary-500" size={40} />,
  },
  {
    id: 3,
    title: 'Enterprise Solutions',
    description: 'Scalable and secure enterprise software solutions that streamline operations and boost productivity.',
    icon: <FaServer className="text-primary-500" size={40} />,
  },
  {
    id: 4,
    title: 'Custom Software',
    description: 'Tailor-made software solutions designed to address your unique business challenges and requirements.',
    icon: <FaCogs className="text-primary-500" size={40} />,
  },
  {
    id: 5,
    title: 'UI/UX Design',
    description: 'Intuitive and visually appealing interfaces that enhance user engagement and satisfaction.',
    icon: <FaPalette className="text-primary-500" size={40} />,
  },
];

const Services = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <section id="services" className="section bg-secondary-50">
      <div className="container">
        <div className="mb-12 text-center">
          <h2 className="section-title">Our Services</h2>
          <p className="max-w-2xl mx-auto text-lg text-secondary-600">
            We offer a comprehensive range of software development services to help businesses thrive in the digital age.
          </p>
        </div>

        <motion.div
          className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              className="glass-card p-6 rounded-xl relative overflow-hidden"
              whileHover={{ y: -10, boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, type: "spring", stiffness: 100 }}
              viewport={{ once: true, margin: "-50px" }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary-600/10 to-secondary-600/10 backdrop-blur-md -z-10"></div>
              <motion.div 
                className="text-primary-600 mb-4 inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary-50"
                whileHover={{ rotate: 5, scale: 1.1 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                {service.icon}
              </motion.div>
              <h3 className="text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-secondary-600">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
